export default "__VITE_ASSET__f79995b9__"